import { useState } from "react";

import { Autocomplete, TextField } from "@mui/material";

export const SearchSettingsSelect = ({
	setValue,
	label,
	options = [],
	sx = [],
	disableClearable = true,
	disabled = false,
	fullWidth = true,
	...props
}) => {
	const [inputValue, setInputValue] = useState("");

	return (
		<Autocomplete
			size="small"
			openText="Открыть"
			closeText="Закрыть"
			clearText="Очистить"
			noOptionsText="Нет данных"
			fullWidth={fullWidth}
			disableClearable={disableClearable}
			getOptionLabel={(option) => option?.name ?? ""}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			onChange={
				setValue
					? (_, newValue) => {
							setValue(newValue);
					  }
					: undefined
			}
			inputValue={inputValue}
			onInputChange={(_, newInputValue) => {
				setInputValue(newInputValue);
			}}
			options={options}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					disabled={disabled}
					InputLabelProps={{
						shrink: true,
					}}
				/>
			)}
			sx={[
				{
					"& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
						padding: 0,
					},
					"& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment": {
						right: "6px",
						top: "calc(50% - 13px)",
					},
					"& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiOutlinedInput-input": {
						fontSize: "12px",
						padding: "2px 6px",
					},
					"& .MuiFormLabel-root": {
						fontSize: "12px",
						top: "2px",
					},
					"& .MuiSvgIcon-root": {
						fontSize: "14px",
					},
					"& legend": {
						fontSize: "9px",
					},
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
			{...props}
		/>
	);
};
